<template>
  <div class="w-100 makers-container" :style="makerStyle">
    <div class="container">
      <BRow class="w-100 align-items-center mt-5">
        <BCol
          v-for="(maker, index) in makers"
          :key="index"
          @click="changeMaker(index, maker.gaName)"
        >
          <div class="option">
            <h2 class="maker-title" :class="{ selected: isSelected(index) }">
              {{ maker.title }}
            </h2>
          </div>
          <div class="option-border" :class="{ 'selected-border': isSelected(index) }"></div>
        </BCol>
      </BRow>
    </div>

    <div class="container">
      <div class="row content-container">
        <div class="col-md-6 col-12 image-container">
          <BImgLazy
            :src="`https://cdn.vexels.com/img/${makers[selectedMaker].imagePath}`"
            fluid
            :alt="$t('home.pre-home.makers.imageAlt')"
            class="float-center"
            height="427"
            width="510"
          />
        </div>
        <div class="col-md-6 col-12">
          <BRow cols="1" class="w-100">
            <BCol class="subtitle">{{ makers[selectedMaker].description }}</BCol>
            <BCol class="button see-more-button">
              <Button
                shape="outline"
                color="transparent"
                text="white"
                :blank="true"
                :to="makers[selectedMaker].url"
                @click="
                  $ga.event(
                    'Home Hibrida',
                    'Click Button Tools Home Hibrida',
                    makers[selectedMaker].url
                  )
                "
              >
                {{ $t(`home.pre-home.makers.${makers[selectedMaker].translationName}Button`) }}
              </Button>
            </BCol>
          </BRow>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BImgLazy, BRow, BCol } from 'bootstrap-vue';
import Button from 'UI/Button';

export default {
  components: {
    BImgLazy,
    Button,
    BRow,
    BCol
  },
  data() {
    return {
      makers: [
        {
          title: this.$t('home.pre-home.makers.mockupTitle'),
          description: this.$t('home.pre-home.makers.mockupDescription'),
          imagePath: 'maker-mockup-generator.png',
          url: 'https://mockups.vexels.com/',
          color: '#5388F2',
          gaName: 'Mockup Generator',
          translationName: 'mockup'
        },
        {
          title: this.$t('home.pre-home.makers.tshirtMakerTitle'),
          description: this.$t('home.pre-home.makers.tshirtMakerDescription'),
          imagePath: 'maker-t-shirt.png',
          url: 'https://www.vexels.com/t-shirt-maker',
          color: '#fb556b',
          gaName: 'T-shirt Maker',
          translationName: 'tshirt'
        },
        {
          title: this.$t('home.pre-home.makers.logoMakerTitle'),
          description: this.$t('home.pre-home.makers.logoMakerDescription'),
          imagePath: 'maker-logo.png',
          url: 'https://logomaker.vexels.com/',
          color: '#7958B7',
          gaName: 'Logo Maker',
          translationName: 'logo'
        }
      ],
      selectedMaker: 0
    };
  },
  computed: {
    makerStyle() {
      return `
      transition: background-color 0.5s ease;
      background-color: ${this.makers[this.selectedMaker].color};
      `;
    }
  },
  methods: {
    changeMaker(index, gaName) {
      this.$ga.event('Home Hibrida', 'Click Tabs Tools Home Hibrida', gaName);
      this.selectedMaker = index;
    },
    isSelected(index) {
      return this.selectedMaker === index;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-container {
  padding: 30px;
  align-items: center;
}
.image-container {
  @include md {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }
}
.makers-container {
  height: 682px;
  border-radius: 5px;
  @include lg {
    height: auto;
  }
}
.option {
  cursor: pointer;
  margin: 0px 10%;
  padding-bottom: 15px;
  color: rgba($white, 0.45);
  @include lg {
    font-size: 20px;
  }
  .maker-title {
    font-weight: 400;
    font-size: 28px;
    margin: 5px 0;
  }
}
.option-border {
  margin-left: 10%;
  margin-right: 60%;
  border-bottom: 3px transparent;
}
.options {
  align-items: center;
  justify-content: center;
}
.selected {
  color: $white !important;
}
.selected-border {
  border-bottom: 3px solid $white !important;
}
.see-more-button {
  @include lg {
    margin-bottom: 30px;
  }
}
.subtitle {
  font-size: 18px;
  color: $white;
  margin: 40px 0px;
  @include lg {
    font-size: 15px;
  }
}
</style>
